import { Link, useLocation } from "react-router-dom";
import { Lightning, ChartBar } from "@phosphor-icons/react";

/**
 * Compact toggle between LaunchPad (Decks) and Finanzas (Personal CFO).
 * Sits at the very top of a sidebar or topbar.
 */
export default function WorkspaceSwitcher({ collapsed = false }) {
  const location = useLocation();
  const onFinance = location.pathname.startsWith("/finanzas");

  const items = [
    {
      key: "launchpad",
      label: "LaunchPad",
      to: "/dashboard",
      active: !onFinance,
      Icon: Lightning,
      accent: "#2563EB",
    },
    {
      key: "finance",
      label: "Finanzas",
      to: "/finanzas",
      active: onFinance,
      Icon: ChartBar,
      accent: "#10B981",
    },
  ];

  if (collapsed) {
    return (
      <div className="flex flex-col items-center gap-1.5 py-3 border-b border-white/5">
        {items.map((it) => {
          const Icon = it.Icon;
          return (
            <Link
              key={it.key}
              to={it.to}
              data-testid={`ws-switch-${it.key}`}
              title={it.label}
              className={`w-10 h-10 rounded-xl flex items-center justify-center transition border ${
                it.active
                  ? "border-white/20 bg-white/8"
                  : "border-transparent hover:bg-white/5 text-white/50"
              }`}
              style={it.active ? { boxShadow: `inset 0 0 0 1px ${it.accent}55` } : {}}
            >
              <Icon size={18} weight={it.active ? "fill" : "bold"} style={it.active ? { color: it.accent } : {}} />
            </Link>
          );
        })}
      </div>
    );
  }

  return (
    <div
      data-testid="workspace-switcher"
      className="mx-3 mt-3 mb-1 p-1 grid grid-cols-2 gap-1 rounded-2xl bg-black/40 border border-white/8"
    >
      {items.map((it) => {
        const Icon = it.Icon;
        return (
          <Link
            key={it.key}
            to={it.to}
            data-testid={`ws-switch-${it.key}`}
            className={`relative flex items-center justify-center gap-2 py-2 rounded-xl transition text-[11px] font-mono uppercase tracking-[0.16em] font-bold ${
              it.active
                ? "text-white bg-white/10 border border-white/10"
                : "text-white/40 hover:text-white/70"
            }`}
            style={it.active ? { boxShadow: `inset 0 -2px 0 ${it.accent}` } : {}}
          >
            <Icon size={13} weight={it.active ? "fill" : "bold"} style={it.active ? { color: it.accent } : {}} />
            {it.label}
          </Link>
        );
      })}
    </div>
  );
}
